const anchorlinks = (function(){
	/** Private **/
	const mainMenuWrapper     = document.querySelector('.main-menu');
	const mainNavListElements = mainMenuWrapper.querySelectorAll('li');
	const anchorLists         = Array.from(document.querySelectorAll('.anchor-list'));
	const anchorWrapper       = document.querySelector('.main-nav-add');
	const anchorContainer     = anchorWrapper.querySelector('.main-nav-add .container');
	const anchorLinks         = document.querySelectorAll('.anchorLink');
	const spyUIWrapper        = document.querySelector('.scrollSpyUI');

	function hideAllAnchors(showUI = false){
		anchorLists.forEach(list => {
			list.classList.remove('active');
			list.style.left = 0;
			setTimeout(() => {
				// Hide if list isnt active right now
				if(!list.classList.contains('active')) {
					list.style.display = 'none';
				}
			}, 300)
		});
		if(showUI){
			spyUIWrapper.style.opacity = 1;
		}
		anchorContainer.style.minHeight = 0 + 'px';
	}

	function handleMouseOver(event){
			const hoveredList = event.currentTarget;
			const aimList = anchorLists.find(list => list.dataset.parent === hoveredList.dataset.ref);
			hideAllAnchors();
			if (aimList) {
				aimList.style.display = 'block';
				setTimeout(()=> {
					aimList.style.left = (hoveredList.offsetLeft - 15) + 'px';
					aimList.classList.add('active');

					anchorContainer.style.minHeight = aimList.offsetHeight + 30 + 'px';
					spyUIWrapper.style.opacity = 0;
				},0);
			}
	}

	function mainMenuLeave(event){
		const aimElement = event.toElement !== undefined ? event.toElement : (event.relatedTarget ? event.relatedTarget : null);
		if(aimElement && aimElement.classList.contains('main-nav-content')) {
			hideAllAnchors();
			spyUIWrapper.style.opacity = 1;
		}
	}

	function scrollToHash(hashElement,timeout=0){
		setTimeout(()=> {
			window.scrollTo({
				top: hashElement.offsetTop + hashElement.querySelector('.section_title_for_scrollspy').offsetHeight - 205,
				left: 0,
				behavior: 'smooth'
			})
		},timeout);
	}

	function handleAnchorClick(event){
		event.preventDefault();
		const the_link = event.currentTarget.href;
		if(!event.currentTarget.href.includes('#')) {
			fadeOverlay.show(true, () => {
				window.location.href = the_link;
			});
		}
		else
			scrollToHash(document.getElementById(event.currentTarget.dataset.ref))

	}

	/** Public **/
	function setup(){
		//1. Set mouseover event for all
		if(window.getComputedStyle(mainMenuWrapper).position === 'static')
			Array.from(mainNavListElements).forEach(listElement => listElement.addEventListener('mouseenter',handleMouseOver));

		//2. Set mouseout events for mainnav and subnav
		mainMenuWrapper.addEventListener('mouseleave',mainMenuLeave);
		document.querySelector('.main-nav').addEventListener('mouseleave',()=>hideAllAnchors(true));

		//3. Click Events for anchor links
		Array.from(anchorLinks).forEach(link => link.addEventListener('click',handleAnchorClick));
	}

	function responTogoTO(){
		const getParam = window.location.search.substr(1).split('=')[1];
		if(getParam)
			scrollToHash(document.getElementById(getParam),500);
	}

	return {
		setup : setup,
		autoscroll : responTogoTO
	};
})();